import React from "react";
import ButtonIcon, {ButtonType} from "../../atoms/button/buttonIcon";
import {IconSource} from "../../../shared/enums/iconSource";
import "./pageHeading.sass";
import {Color} from "../../../shared/enums/color";
import HaloIcon from "../../molecules/haloIcon/haloIcon";
import HeaderColor from "../../atoms/headerColor/headerColor";

export interface IPageHeadingProps {
  title: string;
  actionTitle?: string;
  actionIcon?: IconSource;
  actionType?: ButtonType;
  isActionDisabled?: boolean;
  haloIcon?: IconSource;
  haloColor?: Color;
  onActionClicked?: () => void;
}

const PageHeading: React.FC<IPageHeadingProps> = ({
  title,
  actionTitle,
  actionIcon,
  actionType = "primary",
  haloIcon,
  onActionClicked,
  isActionDisabled,
  haloColor
}) => {
  return (
    <>
      {haloColor && <HeaderColor color={haloColor} />}
      <div className="page-heading">
        <div>
          {haloIcon && haloColor && (
            <HaloIcon iconSource={haloIcon} haloColor={haloColor} />
          )}
          <div data-testid="title">{title}</div>
        </div>
        {actionTitle && actionIcon && (
          <div>
            <ButtonIcon
              type={actionType}
              icon={actionIcon}
              isDisabled={isActionDisabled}
              onClick={onActionClicked}
            >
              {actionTitle}
            </ButtonIcon>
          </div>
        )}
      </div>
    </>
  );
};

export default PageHeading;
